var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg16 = function Svg16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 19,
    r: 1,
    fill: "#9BAFC2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19,
    r: 1,
    fill: "#9BAFC2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 25,
    r: 1,
    fill: "#9BAFC2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 28,
    r: 1,
    fill: "#9BAFC2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 28,
    r: 1,
    fill: "#9BAFC2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 13,
    r: 1,
    fill: "#9BAFC2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 22,
    r: 1,
    fill: "#9BAFC2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 22,
    r: 1,
    fill: "#9BAFC2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 25,
    r: 1,
    fill: "#9BAFC2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 7,
    r: 1,
    fill: "#9BAFC2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 10,
    r: 1,
    fill: "#9BAFC2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 4,
    r: 1,
    fill: "#9BAFC2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 4,
    r: 1,
    fill: "#9BAFC2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 4,
    r: 1,
    fill: "#9BAFC2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 7,
    r: 1,
    fill: "#9BAFC2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 10,
    r: 1,
    fill: "#9BAFC2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 13,
    r: 1,
    fill: "#9BAFC2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 16,
    r: 1,
    fill: "#9BAFC2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 16,
    r: 1,
    fill: "#9BAFC2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 19,
    r: 1,
    fill: "#9BAFC2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 22,
    r: 1,
    fill: "#9BAFC2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 25,
    r: 1,
    fill: "#9BAFC2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 28,
    r: 1,
    fill: "#9BAFC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6177 7.93653C15.5041 7.30282 16.6111 7 17.5946 7C18.422 7 19.4987 7.27788 20.3897 7.98035C21.3199 8.71379 22 9.87632 22 11.5C22 13.4166 21.0041 14.5958 19.8711 15.2432C18.7998 15.8554 17.6133 16 17 16H3C2.44772 16 2 15.5523 2 15C2 14.4477 2.44772 14 3 14H17C17.3867 14 18.2002 13.8946 18.8789 13.5068C19.4959 13.1542 20 12.5834 20 11.5C20 10.4987 19.6084 9.91121 19.1514 9.5509C18.6551 9.15962 18.0291 9 17.5946 9C16.9835 9 16.2932 9.19718 15.7809 9.56347C15.2931 9.91227 15 10.3809 15 11C15 11.5523 14.5523 12 14 12C13.4477 12 13 11.5523 13 11C13 9.61912 13.7069 8.58773 14.6177 7.93653Z",
    fill: "#9BAFC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 23C9 25.1653 11.068 27 13.5946 27C16.0702 27 18 25.0342 18 22.5C18 20.9332 17.3462 19.7302 16.1658 18.9713C15.0565 18.2582 13.5811 18 12 18H3C2.44772 18 2 18.4477 2 19C2 19.5523 2.44772 20 3 20H12C13.4189 20 14.4435 20.2418 15.0842 20.6537C15.6538 21.0198 16 21.5668 16 22.5C16 23.9658 14.9298 25 13.5946 25C11.932 25 11 23.8347 11 23C11 22.4477 10.5523 22 10 22C9.44772 22 9 22.4477 9 23Z",
    fill: "#9BAFC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82746 5.44564C8.31318 5.16629 8.88859 5 9.60811 5C10.9479 5 12.5 6.11127 12.5 8C12.5 8.67378 12.3285 9.26274 11.9826 9.74174C11.6411 10.2145 11.1858 10.5027 10.7464 10.6785C9.93977 11.0011 9.02672 11.0004 8.54636 11C8.53043 11 8.51497 11 8.5 11H3C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9H8.5C9.03398 9 9.58699 8.98817 10.0036 8.82152C10.1892 8.7473 10.2964 8.66053 10.3612 8.57076C10.4215 8.48726 10.5 8.32622 10.5 8C10.5 7.34651 9.97873 7 9.60811 7C9.21952 7 8.99087 7.08371 8.82457 7.17936C8.63077 7.29082 8.4691 7.44511 8.20711 7.70711C7.81658 8.09763 7.18342 8.09763 6.79289 7.70711C6.40237 7.31658 6.40237 6.68342 6.79289 6.29289C6.80115 6.28463 6.80953 6.27624 6.81803 6.26773C7.05452 6.03099 7.38513 5.70004 7.82746 5.44564Z",
    fill: "#9BAFC2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/16.bc8edc3b.svg";
export { ForwardRef as ReactComponent };